import * as React from 'react'
import './index.scss'
import {useAppSelector} from "../../redux";
import {Box, CircularProgress} from "@mui/material";
import moment from 'moment'
import EqualizerIcon from "@mui/icons-material/Equalizer";
import {useNavigate} from "react-router-dom";

export default function GameH2H(props: any) {
    const navigate = useNavigate();
    const { activeGame, headToHead, lastGamesHomeTeam, lastGamesAwayTeam, h2hLoading } = useAppSelector(state => state.fixtures)

    if (h2hLoading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center' }}>
            <CircularProgress size={20}/>
        </Box>
    }

    const {forms, teams} = transformData(activeGame, headToHead, lastGamesHomeTeam, lastGamesAwayTeam)

    const onClickGame = async (event: any) => {
        navigate(`/football/match/${event.id}`);
    }

    const browserTimezone = moment.tz.guess();

    return (
        <div className="game-h2h">
            <div className="form-wrapper">
                <div className="title">Form</div>

                {forms.map((form: any, index: number) => (
                    <div className='form' key={`${form.name}-${index}`}>
                        <div className="form-wrapper-logo">
                            <div className="form-logo" style={{
                                backgroundImage: `url(${form.image + '/small'})`
                            }}></div>
                            <div className='name'>{form.name}</div>
                        </div>
                        <div className='results'>
                            {form.results.map((result: string, index: number) => (
                                <div className={`result ${result}`}
                                     key={`${form.name}-result-${index}`}>{result.toUpperCase().charAt(0)}</div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
            <div className="direct">
                {teams.map((team: any, index: number) => (
                    <div className='h2h' key={`${team.name}-${index}`}>
                        {team.tournaments.length > 0 &&
                            <div className="h2h-type">
                                <span>{team.name}</span>
                                <span>Average goals: {team.averageGoals.toFixed(2)}</span>
                            </div>
                        }
                        {
                            team.tournaments.map((tournament: any, index: number) => (
                                <div>
                                    <div className="competition" key={`${team.name}-${tournament.name}-${index}`}>
                                        <div className='left-wrapper'>
                                            <div className="logo" style={{
                                                backgroundImage: `url(${tournament.logo})`
                                            }}></div>
                                            <div className='name'>{tournament.name}</div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="games">
                                            {tournament.games.map((game: any, index: number) => (
                                                <div key={game.id + '-' + index} className="game" onClick={() => onClickGame(game)}>
                                                    <div
                                                        className={"teams-info-wrapper"}>
                                                        <div className='teams-info'>
                                                            <div style={{
                                                                display: 'flex',
                                                                flexDirection: 'column'
                                                            }}>
                                                                <div
                                                                    className={'team' + (team.name.indexOf(game.homeTeam.shortName) !== -1 || team.name.indexOf('Head-To-Head') !== -1 ? ' team-in-front' : '')}>
                                                                    {game.homeScore?.hasOwnProperty('display') ?
                                                                        <span>{game.homeScore?.display}</span> :
                                                                        <span style={{color: 'transparent'}}>-</span>}

                                                                    <div className="logo" style={{
                                                                        backgroundImage: `url(${game.homeTeam.image + '/small'})`
                                                                    }}></div>
                                                                    <div
                                                                        className='name'
                                                                        style={{fontWeight: '400'}}
                                                                    >{game.homeTeam.shortName}</div>
                                                                    {
                                                                        game.homeRedCards &&
                                                                        <svg
                                                                            className="sr-momentum__event-icon  srt-fill-soccer-red-card"
                                                                            xmlns="http://www.w3.org/2000/svg"
                                                                            viewBox="0 0 16 24"
                                                                            style={{
                                                                                width: '16px',
                                                                                height: '16px',
                                                                                marginLeft: '5px'
                                                                            }}
                                                                        >
                                                                            <path
                                                                                d="M2 0h12c1 0 2 1 2 2v20c0 1-1 2-2 2H2c-1 0-2-1-2-2V2c0-1 1-2 2-2z"></path>
                                                                        </svg>
                                                                    }
                                                                </div>
                                                                <div
                                                                    className={'team' + (team.name.indexOf(game.awayTeam.shortName) !== -1 || team.name.indexOf('Head-To-Head') !== -1 ? ' team-in-front' : '')}>
                                                                    {game.awayScore?.hasOwnProperty('display') ?
                                                                        <span>{game.awayScore?.display}</span> :
                                                                        <span style={{color: 'transparent'}}>-</span>}
                                                                    <div className="logo" style={{
                                                                        backgroundImage: `url(${game.awayTeam.image + '/small'})`
                                                                    }}></div>
                                                                    <div
                                                                        className='name'
                                                                        style={{fontWeight: '400'}}
                                                                    >
                                                                        {game.awayTeam.shortName}

                                                                        {
                                                                            game.awayRedCards &&
                                                                            <svg
                                                                                className="sr-momentum__event-icon  srt-fill-soccer-red-card"
                                                                                xmlns="http://www.w3.org/2000/svg"
                                                                                viewBox="0 0 16 24"
                                                                                style={{
                                                                                    width: '16px',
                                                                                    height: '16px',
                                                                                    marginLeft: '5px'
                                                                                }}
                                                                            >
                                                                                <path
                                                                                    d="M2 0h12c1 0 2 1 2 2v20c0 1-1 2-2 2H2c-1 0-2-1-2-2V2c0-1 1-2 2-2z"></path>
                                                                            </svg>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="time-section-wrapper">
                                                            {(game.settings.hasEventPlayerStatistics || game.settings.hasEventPlayerHeatMap) && (
                                                                    <div className="graph-available">
                                                                        <EqualizerIcon/>
                                                                    </div>
                                                                )}
                                                                <div className='time-info-fixture'>
                                                                    <span>{moment.unix(game.startTimestamp).tz(browserTimezone).format('DD/MM/YYYY')}</span>
                                                                </div>
                                                                <div
                                                                    className={`result ${game.result}`}>{game.result !== 'HTH' ? game.result.toUpperCase().charAt(0) : ''}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </div>))
                }
            </div>
        </div>
    )
}

function transformData(activeGame, headToHeadGames, homeGames, awayGames) {
    const headToHeadMatches = {
        name: "Head-To-Head matches",
        averageGoals: 0,
        tournaments: []
    };

    let currentTournament = null;

    // Process head-to-head games
    headToHeadGames.forEach(match => {
        const tournamentName = match.tournament.name;
        const tournamentLogo = match.tournament.uniqueTournament?.image;

        // Check if we are still within the same tournament
        if (!currentTournament || currentTournament.name !== tournamentName) {
            // If it's a new tournament or the first one, start a new group
            currentTournament = {
                name: tournamentName,
                logo: tournamentLogo,
                games: []
            };
            headToHeadMatches.tournaments.push(currentTournament);
        }

        // Add the match to the current tournament's games list
        currentTournament.games.push({
            ...match,
            score: `${match.homeScore.current}-${match.awayScore.current}`,
            result: 'HTH'
        });
    });

    // Calculate average goals for head-to-head matches
    const allHeadToHeadGames = headToHeadMatches.tournaments.flatMap(tournament => tournament.games);
    headToHeadMatches.averageGoals = allHeadToHeadGames.reduce((acc, val) => {
        const goals = val.score.split('-');
        return acc + parseInt(goals[0]) + parseInt(goals[1]);
    }, 0) / allHeadToHeadGames.length;

    // Process last home games
    const lastGamesHome = {
        name: `Last games: ${activeGame.homeTeam.shortName}`,
        tournaments: [],
        averageGoals: 0
    };

    currentTournament = null;

    homeGames.forEach(match => {
        const tournamentName = match.tournament.name;
        const tournamentLogo = match.tournament.uniqueTournament?.image;
        const isHome = match.homeTeam.id === activeGame.homeTeam.id;
        const homeTeamWon = match.homeScore.current > match.awayScore.current;
        const isDraw = match.awayScore.current === match.homeScore.current;

        const result = isHome
            ? (isDraw ? "draw" : (homeTeamWon ? 'won' : 'lost'))
            : (isDraw ? "draw" : (homeTeamWon ? 'lost' : 'won'));

        if (!currentTournament || currentTournament.name !== tournamentName) {
            currentTournament = {
                name: tournamentName,
                logo: tournamentLogo,
                games: []
            };
            lastGamesHome.tournaments.push(currentTournament);
        }

        currentTournament.games.push({
            ...match,
            score: `${match.homeScore.current}-${match.awayScore.current}`,
            result: result
        });
    });

    const allHomeGames = lastGamesHome.tournaments.flatMap(tournament => tournament.games);
    lastGamesHome.averageGoals = allHomeGames.reduce((acc, val) => {
        const goals = val.score.split('-');
        return acc + parseInt(goals[0]) + parseInt(goals[1]);
    }, 0) / allHomeGames.length;

    // Process last away games
    const lastGamesAway = {
        name: `Last games: ${activeGame.awayTeam.shortName}`,
        tournaments: [],
        averageGoals: 0
    };

    currentTournament = null;

    awayGames.forEach(match => {
        const tournamentName = match.tournament.name;
        const tournamentLogo = match.tournament.uniqueTournament?.image;
        const isAway = match.awayTeam.id === activeGame.awayTeam.id;
        const awayTeamWon = match.awayScore.current > match.homeScore.current;
        const isDraw = match.awayScore.current === match.homeScore.current;

        const result = isAway
            ? (isDraw ? "draw" : (awayTeamWon ? 'won' : 'lost'))
            : (isDraw ? "draw" : (awayTeamWon ? 'lost' : 'won'));

        if (!currentTournament || currentTournament.name !== tournamentName) {
            currentTournament = {
                name: tournamentName,
                logo: tournamentLogo,
                games: []
            };
            lastGamesAway.tournaments.push(currentTournament);
        }

        currentTournament.games.push({
            ...match,
            score: `${match.homeScore.current}-${match.awayScore.current}`,
            result: result
        });
    });

    const allAwayGames = lastGamesAway.tournaments.flatMap(tournament => tournament.games);
    lastGamesAway.averageGoals = allAwayGames.reduce((acc, val) => {
        const goals = val.score.split('-');
        return acc + parseInt(goals[0]) + parseInt(goals[1]);
    }, 0) / allAwayGames.length;

    return {
        forms: [
            {name: activeGame.homeTeam.shortName, image: activeGame.homeTeam.image, results: allHomeGames.map(game => game.result)},
            {name: activeGame.awayTeam.shortName, image: activeGame.awayTeam.image, results: allAwayGames.map(game => game.result)}
        ],
        teams: [headToHeadMatches, lastGamesHome, lastGamesAway]
    };
}

